<template>
    <modal
        printButton
        downloadButton
        :close="closeModal"
        class="modal"
        :printStyle="printStyle"
        :title="title"
    >
    <h3 class="modal__header" slot="modalHeader">
        <i class="uk-icon-sitemap"></i>
        Филиалы и представительства
    </h3>
    <div ref="htmlContent" class="modal__body" slot="modalBody">
        <branches-table inModal :type="type" :list="list" />
    </div>
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import branchesTable from '@/components/card/branches/branchesTable.vue'

export default {
    props: {
        list: Array,
        type: {
            type: String,
            ddefault: 'fns'
        },
        title: {
            type: String,
            default: ''
        },
        printStyle: {
            type: String,
            default: ''
        }
    },
    components: {
        modal,
        branchesTable
    },
    methods: {
        closeModal() { this.$emit('close') }
    }
}
</script>

<style lang="sass" scoped>
.modal
    &__header
        font-family: Arial,Tahoma,sans-serif
        font-weight: 100
        font-size: 24px
        line-height: 24px
        font-size: 24px
    &__body
        padding: 20px
</style>